module.exports = __webpack_public_path__ + "static/8-FOSTERING-COMMUNITY-0eb45be77e72bb6ca0550fc89ccb40c0.png";